import { useContext, useEffect, useState } from "react";
import { StoreContext } from "../../Context/StoreContext";
import LimitedTextarea from "../LimitedTextarea";
import globals from "../../globals";
import Button from "../Button";
import Loader from "../Loader";
import {
  getSubscriberApprovalSubmission,
  submitSubscriberApproval,
} from "../../services/rooomService";

function SubscriberApprovalQuestionsModal() {
  const { state } = useContext(StoreContext);
  const {
    auth: { user },
    room: {
      liveRoom: { liveRoom: room },
    },
  } = state;
  const [answers, setAnswers] = useState(["", "", ""]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingApproval, setIsLoadingApproval] = useState(true);
  const [answerErr, setAnswerErr] = useState("");

  const handleAnswerChange = (index: number, value: string) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswerErr("");
    setAnswers(newAnswers);
  };

  const handleSubmitAnswer = async () => {
    try {
      if (answers.some((answer) => answer.trim() === "") || !answers.length) {
        setAnswerErr("Please enter all your answers");
        return;
      }
      setIsSubmitting(true);
      await submitSubscriberApproval(user?.token, { answers, room: room._id });
      globals.hideModal();
      window.location.reload();
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const getSubmission = async () => {
      try {
        const response = await getSubscriberApprovalSubmission(
          user?.token,
          room._id,
          user?._id,
        );
        if (response.data?.answers) {
          setAnswers(response.data?.answers);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingApproval(false);
      }
    };
    if (user && room) {
      getSubmission();
    }
  }, [user, room]);

  if (isLoadingApproval) {
    return <Loader />;
  }

  return (
    <div className="px-2">
      {room.approvalQuestions.map((question: any, index: number) => (
        <div key={index}>
          <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
            {question}
          </p>
          <LimitedTextarea
            limit={500}
            value={answers[index]}
            rows={3}
            onChange={(value: string) => handleAnswerChange(index, value)}
            placeHolder=""
          />
        </div>
      ))}
      {!!answerErr && <p className="text-xs text-cvRed">{answerErr}</p>}
      <div className=" py-3 flex flex-row-reverse ">
        {isSubmitting ? (
          <Loader />
        ) : (
          <Button
            size="vibhut-sm"
            variant="vibhut-primary"
            onClick={handleSubmitAnswer}
          >
            Submit
          </Button>
        )}
        <div className="mr-3">
          <Button
            size="vibhut-sm"
            variant="vibhut-secondary"
            onClick={() => globals.hideModal()}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SubscriberApprovalQuestionsModal;
